// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JAzr","label":"styles_label__1T3mP"};